module.exports = __webpack_public_path__ + "static/media/caret_right_icon.7486bc1a.png";